// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { h } from '@stencil/core';
import { WidgetStyle } from '../../addi-product-widget/addi-product-widget.d';
import { BannerConfig } from '../../addi-product-banner/addi-product-banner.d';

const renderBadge = (
  customBannerStyle: WidgetStyle,
  showSkeleton: boolean
): HTMLElement => (
  <div class="addi-banner-bagde addi-banner-custom-bagde">
    {renderBadgeIcon(customBannerStyle, showSkeleton)}
  </div>
);

const renderBadgeIcon = (
  customBannerStyle: WidgetStyle,
  showSkeleton: boolean
): HTMLElement => {
  const skeletonClass = showSkeleton ? 'loading' : '';
  const iconClass = `addi-banner-bagde__icon--${customBannerStyle?.iconType}`;
  const customStyles = customBannerStyle?.iconSize
    ? {
        width: customBannerStyle.iconSize,
        height: customBannerStyle.iconSize,
        display: 'block',
      }
    : {};

  return (
    <div class={`${iconClass} ${skeletonClass}`} style={customStyles}></div>
  );
};

const renderInfo = (
  config: BannerConfig,
  showSkeleton: boolean
): HTMLElement => {
  const message = showSkeleton ? '' : generateMessage(config);
  return (
    <div class="addi-banner-info addi-banner-custom-info">
      <div class={`addi-banner-info__message ${showSkeleton ? 'loading' : ''}`}>
        {message}
        <svg
          width="14"
          height="14"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M6.99992 13.6667C3.31802 13.6667 0.333252 10.6819 0.333252 7.00004C0.333252 3.31814 3.31802 0.333374 6.99992 0.333374C10.6818 0.333374 13.6666 3.31814 13.6666 7.00004C13.6625 10.6803 10.6801 13.6627 6.99992 13.6667ZM1.66659 7.11471C1.69813 10.0489 4.09399 12.4064 7.02828 12.3907C9.96257 12.3749 12.3329 9.9917 12.3329 7.05737C12.3329 4.12304 9.96257 1.73989 7.02828 1.72404C4.09399 1.70835 1.69813 4.06588 1.66659 7.00004V7.11471ZM8.33325 10.3334H6.33325V7.66671H5.66659V6.33337H7.66659V9.00004H8.33325V10.3334ZM7.66659 5.00004H6.33325V3.66671H7.66659V5.00004Z"
            fill="#3C6AF0"
          />
        </svg>
      </div>
    </div>
  );
};

const generateMessage = ({
  id,
  preapproval,
}: BannerConfig): Record<string, unknown> => {
  const linkLabel = preapproval ? 'Obter pré-aprovado' : 'Saiba mais';

  return (
    <div>
      <strong class="addi-banner-info__message--strong">Pix parcelado</strong>{' '}
      em parcelas que cabem no seu bolso &nbsp;
      <button
        id={`show-more-btn_${id}`}
        class="addi-banner-button addi-banner-button--link"
      >
        {' '}
        {linkLabel}
      </button>
    </div>
  );
};

const buildBanner = (config: BannerConfig): HTMLElement => {
  const showSkeleton = !config.id;
  const badgeComponent = renderBadge(config.customBannerStyle, showSkeleton);
  const infoComponent = renderInfo(config, showSkeleton);

  return (
    <div class="addi-banner-wrapper">
      <div
        id={`addi-banner_${config.id}`}
        class={`addi-banner addi-banner-custom ${
          config?.proposal?.discount && 'addi-banner--with-discount'
        }`}
      >
        {badgeComponent}
        {infoComponent}
      </div>
    </div>
  );
};

export const BNPLWidgetBR4x = (config: BannerConfig): HTMLElement => {
  const bannerComponent = buildBanner(config);

  return (
    <div>
      {config?.proposal?.discount ? (
        <div class="addi-banner-discount addi-banner-custom-discount">
          {config.proposal.discount * 100}% de desconto extra
        </div>
      ) : (
        ''
      )}
      {bannerComponent}
    </div>
  );
};
